"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOfferStateToByte = exports.getOfferFiatCurrencyOffset = exports.getOfferMakerAddressOffset = exports.getOfferStateOffset = exports.mapSideToByte = exports.mapTradeStateToByte = exports.getTradeFiatCurrencyOffset = exports.getTradeSellOfferIdOffset = exports.getTradeBuyOfferIdOffset = exports.getTradeSellerAddressOffset = exports.getTradeBuyerAddressOffset = exports.getTradeStateOffSet = void 0;
const types_1 = require("../types");
const bytes_1 = require("@project-serum/anchor/dist/cjs/utils/bytes");
const lodash_1 = require("lodash");
const getTradeStateOffSet = () => {
    return (8 + // DISCRIMINATOR
        8 + // sell offer id
        8 + // buy offer id
        8 + // trade id
        8 + // trade id seed
        1 // side
    );
};
exports.getTradeStateOffSet = getTradeStateOffSet;
const getTradeBuyerAddressOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // sell offer id
        8 + // buy offer id
        8 + // trade id
        8 + // trade id seed
        1 + // side
        1 + // trade state
        1 + // seller bond type
        1 + // buyer bond type
        32 + // market_account
        32 + // seller address
        32 // seller token account
    );
};
exports.getTradeBuyerAddressOffset = getTradeBuyerAddressOffset;
const getTradeSellerAddressOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // sell offer id
        8 + // buy offer id
        8 + // trade id
        8 + // trade id seed
        1 + // side
        1 + // trade state
        1 + // seller bond type
        1 + // buyer bond type
        32 // market_account
    );
};
exports.getTradeSellerAddressOffset = getTradeSellerAddressOffset;
const getTradeBuyOfferIdOffset = () => {
    return (8 + // DISCRIMINATOR
        8 // sell offer id
    );
};
exports.getTradeBuyOfferIdOffset = getTradeBuyOfferIdOffset;
const getTradeSellOfferIdOffset = () => {
    return 8; // DISCRIMINATOR
};
exports.getTradeSellOfferIdOffset = getTradeSellOfferIdOffset;
const getTradeFiatCurrencyOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // sell offer id
        8 + // buy offer id
        8 + // trade id
        8 + // trade id seed
        1 + // side
        1 + // trade state
        1 + // seller bond type
        1 + // buyer bond type
        32 + // market_account
        32 + // seller_authority
        32 + // seller_token_account
        32 + // buyer_authority
        32 + // buyer_token_account
        32 + // token_mint
        4 // fiat_currency offset
    );
};
exports.getTradeFiatCurrencyOffset = getTradeFiatCurrencyOffset;
const mapTradeStateToByte = (tradeState) => {
    let tradeStateIntValue;
    if ((0, lodash_1.isEqual)(tradeState, types_1.TradeState.Awaiting)) {
        tradeStateIntValue = 0;
    }
    else if ((0, lodash_1.isEqual)(tradeState, types_1.TradeState.Deposited)) {
        tradeStateIntValue = 1;
    }
    else if ((0, lodash_1.isEqual)(tradeState, types_1.TradeState.Disputed)) {
        tradeStateIntValue = 2;
    }
    else if ((0, lodash_1.isEqual)(tradeState, types_1.TradeState.Released)) {
        tradeStateIntValue = 3;
    }
    else if ((0, lodash_1.isEqual)(tradeState, types_1.TradeState.Canceled)) {
        tradeStateIntValue = 4;
    }
    else {
        tradeStateIntValue = 0; // default value
    }
    let value = bytes_1.bs58.encode(Buffer.from([tradeStateIntValue]));
    return value;
};
exports.mapTradeStateToByte = mapTradeStateToByte;
const mapSideToByte = (tradeSide) => {
    let tradeSideIntValue;
    if ((0, lodash_1.isEqual)(tradeSide, types_1.TradeSide.Buy)) {
        tradeSideIntValue = 0;
    }
    else if ((0, lodash_1.isEqual)(tradeSide, types_1.TradeSide.Sell)) {
        tradeSideIntValue = 1;
    }
    else {
        tradeSideIntValue = 0; // default value
    }
    let value = bytes_1.bs58.encode(Buffer.from([tradeSideIntValue]));
    return value;
};
exports.mapSideToByte = mapSideToByte;
const getOfferStateOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // offer id
        8 + // offer id seed
        1 // side
    );
};
exports.getOfferStateOffset = getOfferStateOffset;
const getOfferMakerAddressOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // offer id
        8 + // offer id seed
        1 + // side
        1 + // state
        1 + // bond type
        32 // market_account
    );
};
exports.getOfferMakerAddressOffset = getOfferMakerAddressOffset;
const getOfferFiatCurrencyOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // offer id
        8 + // offer id seed
        1 + // side
        1 + // state
        1 + // bond type
        32 + // market_account
        32 + // maker_authority
        32 + // maker_token_account
        32 + // token_mint
        4 // fiat currency offset
    );
};
exports.getOfferFiatCurrencyOffset = getOfferFiatCurrencyOffset;
const mapOfferStateToByte = (offerState) => {
    let offerStateIntValue;
    if ((0, lodash_1.isEqual)(offerState, types_1.OfferState.Awaiting)) {
        offerStateIntValue = 0;
    }
    else if ((0, lodash_1.isEqual)(offerState, types_1.OfferState.Canceled)) {
        offerStateIntValue = 1;
    }
    else if ((0, lodash_1.isEqual)(offerState, types_1.OfferState.OutOfFund)) {
        offerStateIntValue = 2;
    }
    else {
        offerStateIntValue = 0; // default value
    }
    let value = bytes_1.bs58.encode(Buffer.from([offerStateIntValue]));
    return value;
};
exports.mapOfferStateToByte = mapOfferStateToByte;
